import React from 'react';
import AppDialog from './AppDialog';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title: string;
  subTitle?: string | React.ReactNode;
  icon?: React.ReactNode;
  confirmBtnText?: string;
  cancelBtnText?: string;
  confirmBtnTextClasses?: string;
  cancelBtnTextClasses?: string;
  bordered?: boolean;
  footer?: React.ReactNode;
  containerClasses?: string;
  buttonsClass?: string;
  width?: number;
};

function AppConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title,
  subTitle,
  icon,
  confirmBtnText,
  cancelBtnText,
  confirmBtnTextClasses,
  cancelBtnTextClasses,
  bordered = true,
  footer,
  containerClasses,
  buttonsClass,
  width = 426,
}: Props) {
  const renderedSubTitle =
    typeof subTitle === 'string' ? (
      <p className="m-0 text-[14px] text-darkerGray text-center">{subTitle}</p>
    ) : (
      <div className="m-0 text-[14px] text-darkerGray text-center">
        {subTitle}
      </div>
    );

  return (
    <AppDialog
      showModel={open}
      onClose={onClose}
      showCloseIcon={false}
      width={width}
      containerClasses={`${!bordered ? '!border-none' : ''}`}>
      <div className={`flex flex-col gap-4 px-[32px] ${containerClasses}`}>
        <div className="flex flex-col items-center gap-3">
          {icon}

          <p className="m-0 text-[24px] text-[#1D1B20] text-center">{title}</p>

          {subTitle && renderedSubTitle}
        </div>

        {footer ? (
          footer
        ) : (
          <div
            className={`flex items-center justify-end gap-10 ${buttonsClass}`}>
            <button
              className={`text-[20px] font-medium text-darkGreen hover:opacity-60 transition-opacity duration-200 ${cancelBtnTextClasses}`}
              onClick={() => onClose()}>
              {cancelBtnText}
            </button>

            <button
              className={`text-[20px] font-medium text-darkGreen hover:opacity-60 transition-opacity duration-200 ${confirmBtnTextClasses}`}
              onClick={() => onConfirm?.()}>
              {confirmBtnText}
            </button>
          </div>
        )}
      </div>
    </AppDialog>
  );
}

export default AppConfirmationDialog;
